import { SET_CLIENTS_LIST } from "store/client/types";

const clientReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_CLIENTS_LIST:
      return {
        ...state,
        list: payload.clientsList,
      };
    default:
      return state;
  }
};

const initialState = {
  list: [],
  selected: null,
};

export default clientReducer;

